import { IS_CLIENT_SIDE } from '@/domains/core/settings/constants';

export const isMobile = () => {
  if (!IS_CLIENT_SIDE) {
    return false;
  }

  let hasTouchScreen = false;
  if ('maxTouchPoints' in navigator) {
    hasTouchScreen = navigator.maxTouchPoints > 0;
  } else if ('msMaxTouchPoints' in navigator) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    hasTouchScreen = navigator.msMaxTouchPoints > 0;
  } else {
    const mQ = window.matchMedia('(pointer:coarse)');
    if (mQ && mQ.media === '(pointer:coarse)') {
      hasTouchScreen = !!mQ.matches;
    } else if ('orientation' in window) {
      hasTouchScreen = true; // deprecated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing
      const UA = (navigator as Navigator).userAgent;
      hasTouchScreen =
        /\b(blackberry|webos|iphone|iemobile)\b/i.test(UA) ||
        /\b(android|windows phone|ipad|ipod)\b/i.test(UA);
    }
  }
  return hasTouchScreen;
};

export const isMobileResolution = (): boolean => {
  if (!IS_CLIENT_SIDE) {
    return false;
  }
  return window.matchMedia('(max-width: 1024px)').matches;
};
